import React, { forwardRef } from 'react';
import { FormLabel, TextField as ToolkitTextField } from '@cko/primitives';
import { FormDescription } from '../FormDescription';
import { FormError } from '../../../_deprecated/FormError';
/**
 * @deprecated - This component is due to be deleted Please remove from your mfe.
 */
export const TextField = forwardRef(({ description, disabled = false, errorMessage, hasError, hideErrorMessage, id, onChange, isRequired, title, ...inputProps }, ref) => {
    return (React.createElement(React.Fragment, null,
        title && (React.createElement(FormLabel, { htmlFor: id, isRequired: isRequired }, title)),
        React.createElement(ToolkitTextField, { ...inputProps, error: hasError, disabled: disabled, onChange: onChange, id: id, ref: ref }),
        description && !hasError && React.createElement(FormDescription, null, description),
        hasError && errorMessage && !hideErrorMessage && React.createElement(FormError, null, errorMessage)));
});
